import React from 'react';
import { Container, Header, Divider } from 'semantic-ui-react';

import './style.css';

class Mission extends React.Component {
  render() {
    return <Container className='Mission' text textAlign='left'>
      <Header as='h1' textAlign='center'>
      Our Mission
    </Header >
    <Divider />
        <p>
          To support and advise “first and best” disruptive innovation
          companies in connection with their (1) product commercialization in the US and Asian
          markets and (2) capital formation, including fundraising and listing.
        </p>
    </Container>;
  }
}

export default Mission;
